import {
  DefaultOptions,
  MutationCache,
  QueryCache,
  QueryClient,
} from "@tanstack/react-query";
import toast from "react-hot-toast";
import { AccessToken } from "../enums/access-token";
import { MutationKeys } from "../enums/react-query";
import { ToastStatus } from "../enums/react-hot-toast";
import { DefaultResponse } from "../types/default-response.dto";
import { SignInResponse } from "../services/auth/sign-in-response.dto";
import { errorParser } from "./error-parser";
import { PopUp } from "@/components/atoms/PopUp";

const defaultOptions: DefaultOptions = {
  queries: {
    staleTime: 0,
    retry: false,
  },
};

export const queryClient = new QueryClient({
  defaultOptions,
  mutationCache: new MutationCache({
    onError(err: unknown) {
      const error = new Error(err as string);
      const parsedError = errorParser(error);
      if (parsedError)
        toast.custom(t => <PopUp message={parsedError} type="error" t={t} />);
    },
    onSettled(res, _, __, ___, mutation) {
      if (!res) return;

      const response = res as DefaultResponse;

      const isSignInMutate =
        mutation.options.mutationKey &&
        mutation.options.mutationKey[0] === MutationKeys.SIGNIN;

      if (isSignInMutate) {
        const data = response.data.payload as SignInResponse;
        if (data) {
          localStorage.setItem(AccessToken.KEY, data.token);
        }
      }

      const { alert } = response?.data || {};
      if (alert) {
        if (alert.type === ToastStatus.SUCCESS && alert.message) {
          toast.custom(t => (
            <PopUp message={alert.message} type="success" t={t} />
          ));
        } else if (alert.type === ToastStatus.ERROR) {
          toast.custom(t => (
            <PopUp message={alert.message} type="error" t={t} />
          ));
        }
      }
    },
  }),
  queryCache: new QueryCache({
    onError(err: unknown) {
      const error = new Error(err as string);
      const parsedError = errorParser(error);
      if (parsedError)
        toast.custom(t => <PopUp message={parsedError} type="error" t={t} />);
    },
    onSettled(res: any) {
      if (!res) return;

      const response = res as DefaultResponse;
      const { alert } = response?.data || {};

      if (alert) {
        if (alert.type === ToastStatus.SUCCESS && alert.message) {
          toast.custom(t => (
            <PopUp message={alert.message} type="success" t={t} />
          ));
        } else if (alert.type === ToastStatus.ERROR) {
          toast.custom(t => (
            <PopUp message={alert.message} type="error" t={t} />
          ));
        }
      }
    },
  }),
});
